<template>
  <div>
    <div class="ui form" id="patient-search-step">
      <div class="field">
        <label for="">Search using mobile phone</label>
        <div class="ui search">
          <div class="ui icon fluid input">

            <input 
              class="prompt" 
              type="text" 
              placeholder="Search patients..." 
              v-model="searchPhoneNumber"
            >
            <i class="search icon"></i>
          </div>
          <!-- <div class="results"></div> -->

          <div class="ui vertical menu" v-if="patients.length">
            <a 
              class="item"
              v-for="patient in patients"
              :key="patient.id"
              @click="setPatient(patient)"
            >
              {{ patient.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      patients: [],
      searchPhoneNumber: null,
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('.ui.search')
          .search({
            minCharacters : 5,
            fields: {
              title   : 'name'
            },
            apiSettings: {
              responseAsync: (settings, callback) => {
                this.$http.get('patients/search-list', {
                  params: {
                    cell_phone: this.searchPhoneNumber,
                    clinic_id: this.getClinicId()
                  }
                }).then(response => {
                  this.patients = response.data.map(patient => ({...patient, name: this.adjustName(patient.name)}))
                })
              }
            }
          })
        
    });
  },
  methods: {
    setPatient(patient) {
      this.$emit('room-patient-search', {
        data: { patient }
      })
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rooms/room_components/visits_popup_components/PatientSearch.vue